class NotificationService {
	static showMessage = null;

	static register(fn) {
		NotificationService.showMessage = fn;
	}

	static notify(message, severity = 'info') {
		if (NotificationService.showMessage) {
			NotificationService.showMessage(message, severity);
		} else {
			console.warn('NotificationService not registered');
		}
	}
}

export default NotificationService;
